<template lang="pug">
  #team-steps-chart
    WtTitle(card-title) Team Averages Over Time
    WtBetweenDatesInput(
      :fetch-action="fetchAction"
      @newData="data = $event"
      :initDates="dates"
      @newDates="dates = $event"
    )
    LineChart(
      v-if="loadedStatus && !_.isEmpty(data)"
      :chart-data="chartData"
      showLegend
    )
    .empty-state(v-if="_.isEmpty(data)")
      p Hey there,
      br
      p A chart will show here when data is available.
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import WtTitle from "@@/WtTitle/WtTitle";
import WtBetweenDatesInput from "@@/WtBetweenDatesInput/WtBetweenDatesInput";
import LineChart from "@/charts/LineChart";

export default {
  name: "TeamStepsChart",

  components: {
    LineChart,
    WtTitle,
    WtBetweenDatesInput
  },

  props: {
    team: {
      type: Object,
      default: () => {
        return {
          id: null,
          name: null,
          description: null,
          public: null,
          inviteOnly: null,
          logo: null,
          maxMembers: null,
          numMembers: null,
          initiationDate: null
        };
      }
    }
  },

  data() {
    return {
      data: null,
      loadedStatus: false,
      dates: [this.moment().subtract(7, "days")._d, this.moment()._d]
    };
  },

  computed: {
    ...mapGetters("program", ["coreProgramMeta"]),

    chartData() {
      const labels = this.data
        .map(day => this.moment(day.date).format("MM/DD/YYYY"))
        .reverse();
      const stepData = this.data.map(day => day.averageSteps).reverse();
      const activityData = this.data
        .map(day => day.averageActivities)
        .reverse();

      const datasets = [
        {
          label: "Average Steps",
          borderColor: "#1ba1c3",
          backgroundColor: "rgba(27, 161, 195, 0.20)",
          data: stepData
        }
      ];
      // Only Show Activities if the ActivityConverter is enabled.
      if (this.coreProgramMeta.converter) {
        datasets.push({
          label: "Average Activities",
          borderColor: "#5fc0ab",
          backgroundColor: "rgba(95, 192, 171, 0.20)",
          data: activityData
        });
      }

      return { labels, datasets };
    }
  },

  async mounted() {
    this.data = await this.fetchTeamStepsData({
      teamId: this.team.id,
      startDate: this.moment().subtract(7, "days")._d,
      endDate: this.moment()._d
    });
    this.loadedStatus = true;
  },

  methods: {
    ...mapActions("teams", ["fetchTeamStepsData"]),

    async fetchAction(params) {
      const response = await this.fetchTeamStepsData({
        teamId: this.team.id,
        startDate: params.startDate,
        endDate: params.endDate
      });

      return response;
    }
  }
};
</script>

<style lang="sass" scoped>
#team-steps-chart
  min-height: 200px
</style>
